export class HeaderImgCount {
   static readonly Home = 3;
   static readonly Others = 1;
}
export class HomeOpinionsImgCount {
   static readonly MeltMeTender = 15;
   static readonly Argasinscy = 4;
   static readonly PaulinaPapiez = 5;
}
export class OfferImgCount {
   static readonly Food = 6;
   static readonly Product = 6;
   static readonly Reportage = 6;
}
export class PortfolioImgCount {
   static readonly Food = 40;
   static readonly Product = 40;
   static readonly Reportage = 28;
}
export type ImagePath =
| `glowna/naglowek-komputer1.jpg`
| `glowna/naglowek-komputer2.jpg`
| `glowna/naglowek-komputer3.jpg`
| `glowna/naglowek-telefon1.jpg`
| `glowna/naglowek-telefon2.jpg`
| `glowna/naglowek-telefon3.jpg`
| `glowna/o-mnie.jpg`
| `glowna/oferta-kulinarna.jpg`
| `glowna/oferta-produktowa.jpg`
| `glowna/oferta-reportazowa.jpg`
| `glowna/opinie/melt-me-tender1.jpg`
| `glowna/opinie/pelnowymiarowe/melt-me-tender1.jpg`
| `glowna/opinie/melt-me-tender2.jpg`
| `glowna/opinie/pelnowymiarowe/melt-me-tender2.jpg`
| `glowna/opinie/melt-me-tender3.jpg`
| `glowna/opinie/pelnowymiarowe/melt-me-tender3.jpg`
| `glowna/opinie/melt-me-tender4.jpg`
| `glowna/opinie/pelnowymiarowe/melt-me-tender4.jpg`
| `glowna/opinie/melt-me-tender5.jpg`
| `glowna/opinie/pelnowymiarowe/melt-me-tender5.jpg`
| `glowna/opinie/melt-me-tender6.jpg`
| `glowna/opinie/pelnowymiarowe/melt-me-tender6.jpg`
| `glowna/opinie/melt-me-tender7.jpg`
| `glowna/opinie/pelnowymiarowe/melt-me-tender7.jpg`
| `glowna/opinie/melt-me-tender8.jpg`
| `glowna/opinie/pelnowymiarowe/melt-me-tender8.jpg`
| `glowna/opinie/melt-me-tender9.jpg`
| `glowna/opinie/pelnowymiarowe/melt-me-tender9.jpg`
| `glowna/opinie/melt-me-tender10.jpg`
| `glowna/opinie/pelnowymiarowe/melt-me-tender10.jpg`
| `glowna/opinie/melt-me-tender11.jpg`
| `glowna/opinie/pelnowymiarowe/melt-me-tender11.jpg`
| `glowna/opinie/melt-me-tender12.jpg`
| `glowna/opinie/pelnowymiarowe/melt-me-tender12.jpg`
| `glowna/opinie/melt-me-tender13.jpg`
| `glowna/opinie/pelnowymiarowe/melt-me-tender13.jpg`
| `glowna/opinie/melt-me-tender14.jpg`
| `glowna/opinie/pelnowymiarowe/melt-me-tender14.jpg`
| `glowna/opinie/melt-me-tender15.jpg`
| `glowna/opinie/pelnowymiarowe/melt-me-tender15.jpg`
| `glowna/opinie/argasinscy1.jpg`
| `glowna/opinie/pelnowymiarowe/argasinscy1.jpg`
| `glowna/opinie/argasinscy2.jpg`
| `glowna/opinie/pelnowymiarowe/argasinscy2.jpg`
| `glowna/opinie/argasinscy3.jpg`
| `glowna/opinie/pelnowymiarowe/argasinscy3.jpg`
| `glowna/opinie/argasinscy4.jpg`
| `glowna/opinie/pelnowymiarowe/argasinscy4.jpg`
| `glowna/opinie/paulina-papiez1.jpg`
| `glowna/opinie/pelnowymiarowe/paulina-papiez1.jpg`
| `glowna/opinie/paulina-papiez2.jpg`
| `glowna/opinie/pelnowymiarowe/paulina-papiez2.jpg`
| `glowna/opinie/paulina-papiez3.jpg`
| `glowna/opinie/pelnowymiarowe/paulina-papiez3.jpg`
| `glowna/opinie/paulina-papiez4.jpg`
| `glowna/opinie/pelnowymiarowe/paulina-papiez4.jpg`
| `glowna/opinie/paulina-papiez5.jpg`
| `glowna/opinie/pelnowymiarowe/paulina-papiez5.jpg`
| `kontakt/naglowek-komputer1.jpg`
| `kontakt/naglowek-telefon1.jpg`
| `loga-klientow/argasinscy.png`
| `loga-klientow/multipak.png`
| `loga-klientow/odlotowe-party.png`
| `loga-klientow/melt-me-tender.png`
| `logo/okragle-czarne.png`
| `logo/okragle-biale.png`
| `logo/okragle-kolor.png`
| `logo/poziome-czarne.png`
| `logo/poziome-biale.png`
| `logo/poziome-kolor.png`
| `o-mnie/naglowek-komputer1.jpg`
| `o-mnie/naglowek-telefon1.jpg`
| `o-mnie/sekcja-1.jpg`
| `o-mnie/sekcja-2-1.jpg`
| `o-mnie/sekcja-2-2.jpg`
| `o-mnie/sekcja-2-3.jpg`
| `o-mnie/sekcja-2-4.jpg`
| `o-mnie/sekcja-3.jpg`
| `o-mnie/sekcja-4-1.jpg`
| `o-mnie/sekcja-4-2.jpg`
| `o-mnie/sekcja-4-3.jpg`
| `o-mnie/sekcja-4-4.jpg`
| `o-mnie/sekcja-4-5.jpg`
| `o-mnie/sekcja-5.jpg`
| `oferta/naglowek-komputer1.jpg`
| `oferta/naglowek-telefon1.jpg`
| `oferta/kulinarna/1.jpg`
| `oferta/kulinarna/pelnowymiarowe/1.jpg`
| `oferta/kulinarna/2.jpg`
| `oferta/kulinarna/pelnowymiarowe/2.jpg`
| `oferta/kulinarna/3.jpg`
| `oferta/kulinarna/pelnowymiarowe/3.jpg`
| `oferta/kulinarna/4.jpg`
| `oferta/kulinarna/pelnowymiarowe/4.jpg`
| `oferta/kulinarna/5.jpg`
| `oferta/kulinarna/pelnowymiarowe/5.jpg`
| `oferta/kulinarna/6.jpg`
| `oferta/kulinarna/pelnowymiarowe/6.jpg`
| `oferta/produktowa/1.jpg`
| `oferta/produktowa/pelnowymiarowe/1.jpg`
| `oferta/produktowa/2.jpg`
| `oferta/produktowa/pelnowymiarowe/2.jpg`
| `oferta/produktowa/3.jpg`
| `oferta/produktowa/pelnowymiarowe/3.jpg`
| `oferta/produktowa/4.jpg`
| `oferta/produktowa/pelnowymiarowe/4.jpg`
| `oferta/produktowa/5.jpg`
| `oferta/produktowa/pelnowymiarowe/5.jpg`
| `oferta/produktowa/6.jpg`
| `oferta/produktowa/pelnowymiarowe/6.jpg`
| `oferta/reportazowa/1.jpg`
| `oferta/reportazowa/pelnowymiarowe/1.jpg`
| `oferta/reportazowa/2.jpg`
| `oferta/reportazowa/pelnowymiarowe/2.jpg`
| `oferta/reportazowa/3.jpg`
| `oferta/reportazowa/pelnowymiarowe/3.jpg`
| `oferta/reportazowa/4.jpg`
| `oferta/reportazowa/pelnowymiarowe/4.jpg`
| `oferta/reportazowa/5.jpg`
| `oferta/reportazowa/pelnowymiarowe/5.jpg`
| `oferta/reportazowa/6.jpg`
| `oferta/reportazowa/pelnowymiarowe/6.jpg`
| `oferta/rodzaj-fotografii/kulinarna.jpg`
| `oferta/rodzaj-fotografii/produktowa.jpg`
| `oferta/rodzaj-fotografii/reportazowa.jpg`
| `portfolio/naglowek-komputer1.jpg`
| `portfolio/naglowek-telefon1.jpg`
| `portfolio/kulinarna/1.jpg`
| `portfolio/kulinarna/pelnowymiarowe/1.jpg`
| `portfolio/kulinarna/2.jpg`
| `portfolio/kulinarna/pelnowymiarowe/2.jpg`
| `portfolio/kulinarna/3.jpg`
| `portfolio/kulinarna/pelnowymiarowe/3.jpg`
| `portfolio/kulinarna/4.jpg`
| `portfolio/kulinarna/pelnowymiarowe/4.jpg`
| `portfolio/kulinarna/5.jpg`
| `portfolio/kulinarna/pelnowymiarowe/5.jpg`
| `portfolio/kulinarna/6.jpg`
| `portfolio/kulinarna/pelnowymiarowe/6.jpg`
| `portfolio/kulinarna/7.jpg`
| `portfolio/kulinarna/pelnowymiarowe/7.jpg`
| `portfolio/kulinarna/8.jpg`
| `portfolio/kulinarna/pelnowymiarowe/8.jpg`
| `portfolio/kulinarna/9.jpg`
| `portfolio/kulinarna/pelnowymiarowe/9.jpg`
| `portfolio/kulinarna/10.jpg`
| `portfolio/kulinarna/pelnowymiarowe/10.jpg`
| `portfolio/kulinarna/11.jpg`
| `portfolio/kulinarna/pelnowymiarowe/11.jpg`
| `portfolio/kulinarna/12.jpg`
| `portfolio/kulinarna/pelnowymiarowe/12.jpg`
| `portfolio/kulinarna/13.jpg`
| `portfolio/kulinarna/pelnowymiarowe/13.jpg`
| `portfolio/kulinarna/14.jpg`
| `portfolio/kulinarna/pelnowymiarowe/14.jpg`
| `portfolio/kulinarna/15.jpg`
| `portfolio/kulinarna/pelnowymiarowe/15.jpg`
| `portfolio/kulinarna/16.jpg`
| `portfolio/kulinarna/pelnowymiarowe/16.jpg`
| `portfolio/kulinarna/17.jpg`
| `portfolio/kulinarna/pelnowymiarowe/17.jpg`
| `portfolio/kulinarna/18.jpg`
| `portfolio/kulinarna/pelnowymiarowe/18.jpg`
| `portfolio/kulinarna/19.jpg`
| `portfolio/kulinarna/pelnowymiarowe/19.jpg`
| `portfolio/kulinarna/20.jpg`
| `portfolio/kulinarna/pelnowymiarowe/20.jpg`
| `portfolio/kulinarna/21.jpg`
| `portfolio/kulinarna/pelnowymiarowe/21.jpg`
| `portfolio/kulinarna/22.jpg`
| `portfolio/kulinarna/pelnowymiarowe/22.jpg`
| `portfolio/kulinarna/23.jpg`
| `portfolio/kulinarna/pelnowymiarowe/23.jpg`
| `portfolio/kulinarna/24.jpg`
| `portfolio/kulinarna/pelnowymiarowe/24.jpg`
| `portfolio/kulinarna/25.jpg`
| `portfolio/kulinarna/pelnowymiarowe/25.jpg`
| `portfolio/kulinarna/26.jpg`
| `portfolio/kulinarna/pelnowymiarowe/26.jpg`
| `portfolio/kulinarna/27.jpg`
| `portfolio/kulinarna/pelnowymiarowe/27.jpg`
| `portfolio/kulinarna/28.jpg`
| `portfolio/kulinarna/pelnowymiarowe/28.jpg`
| `portfolio/kulinarna/29.jpg`
| `portfolio/kulinarna/pelnowymiarowe/29.jpg`
| `portfolio/kulinarna/30.jpg`
| `portfolio/kulinarna/pelnowymiarowe/30.jpg`
| `portfolio/kulinarna/31.jpg`
| `portfolio/kulinarna/pelnowymiarowe/31.jpg`
| `portfolio/kulinarna/32.jpg`
| `portfolio/kulinarna/pelnowymiarowe/32.jpg`
| `portfolio/kulinarna/33.jpg`
| `portfolio/kulinarna/pelnowymiarowe/33.jpg`
| `portfolio/kulinarna/34.jpg`
| `portfolio/kulinarna/pelnowymiarowe/34.jpg`
| `portfolio/kulinarna/35.jpg`
| `portfolio/kulinarna/pelnowymiarowe/35.jpg`
| `portfolio/kulinarna/36.jpg`
| `portfolio/kulinarna/pelnowymiarowe/36.jpg`
| `portfolio/kulinarna/37.jpg`
| `portfolio/kulinarna/pelnowymiarowe/37.jpg`
| `portfolio/kulinarna/38.jpg`
| `portfolio/kulinarna/pelnowymiarowe/38.jpg`
| `portfolio/kulinarna/39.jpg`
| `portfolio/kulinarna/pelnowymiarowe/39.jpg`
| `portfolio/kulinarna/40.jpg`
| `portfolio/kulinarna/pelnowymiarowe/40.jpg`
| `portfolio/produktowa/1.jpg`
| `portfolio/produktowa/pelnowymiarowe/1.jpg`
| `portfolio/produktowa/2.jpg`
| `portfolio/produktowa/pelnowymiarowe/2.jpg`
| `portfolio/produktowa/3.jpg`
| `portfolio/produktowa/pelnowymiarowe/3.jpg`
| `portfolio/produktowa/4.jpg`
| `portfolio/produktowa/pelnowymiarowe/4.jpg`
| `portfolio/produktowa/5.jpg`
| `portfolio/produktowa/pelnowymiarowe/5.jpg`
| `portfolio/produktowa/6.jpg`
| `portfolio/produktowa/pelnowymiarowe/6.jpg`
| `portfolio/produktowa/7.jpg`
| `portfolio/produktowa/pelnowymiarowe/7.jpg`
| `portfolio/produktowa/8.jpg`
| `portfolio/produktowa/pelnowymiarowe/8.jpg`
| `portfolio/produktowa/9.jpg`
| `portfolio/produktowa/pelnowymiarowe/9.jpg`
| `portfolio/produktowa/10.jpg`
| `portfolio/produktowa/pelnowymiarowe/10.jpg`
| `portfolio/produktowa/11.jpg`
| `portfolio/produktowa/pelnowymiarowe/11.jpg`
| `portfolio/produktowa/12.jpg`
| `portfolio/produktowa/pelnowymiarowe/12.jpg`
| `portfolio/produktowa/13.jpg`
| `portfolio/produktowa/pelnowymiarowe/13.jpg`
| `portfolio/produktowa/14.jpg`
| `portfolio/produktowa/pelnowymiarowe/14.jpg`
| `portfolio/produktowa/15.jpg`
| `portfolio/produktowa/pelnowymiarowe/15.jpg`
| `portfolio/produktowa/16.jpg`
| `portfolio/produktowa/pelnowymiarowe/16.jpg`
| `portfolio/produktowa/17.jpg`
| `portfolio/produktowa/pelnowymiarowe/17.jpg`
| `portfolio/produktowa/18.jpg`
| `portfolio/produktowa/pelnowymiarowe/18.jpg`
| `portfolio/produktowa/19.jpg`
| `portfolio/produktowa/pelnowymiarowe/19.jpg`
| `portfolio/produktowa/20.jpg`
| `portfolio/produktowa/pelnowymiarowe/20.jpg`
| `portfolio/produktowa/21.jpg`
| `portfolio/produktowa/pelnowymiarowe/21.jpg`
| `portfolio/produktowa/22.jpg`
| `portfolio/produktowa/pelnowymiarowe/22.jpg`
| `portfolio/produktowa/23.jpg`
| `portfolio/produktowa/pelnowymiarowe/23.jpg`
| `portfolio/produktowa/24.jpg`
| `portfolio/produktowa/pelnowymiarowe/24.jpg`
| `portfolio/produktowa/25.jpg`
| `portfolio/produktowa/pelnowymiarowe/25.jpg`
| `portfolio/produktowa/26.jpg`
| `portfolio/produktowa/pelnowymiarowe/26.jpg`
| `portfolio/produktowa/27.jpg`
| `portfolio/produktowa/pelnowymiarowe/27.jpg`
| `portfolio/produktowa/28.jpg`
| `portfolio/produktowa/pelnowymiarowe/28.jpg`
| `portfolio/produktowa/29.jpg`
| `portfolio/produktowa/pelnowymiarowe/29.jpg`
| `portfolio/produktowa/30.jpg`
| `portfolio/produktowa/pelnowymiarowe/30.jpg`
| `portfolio/produktowa/31.jpg`
| `portfolio/produktowa/pelnowymiarowe/31.jpg`
| `portfolio/produktowa/32.jpg`
| `portfolio/produktowa/pelnowymiarowe/32.jpg`
| `portfolio/produktowa/33.jpg`
| `portfolio/produktowa/pelnowymiarowe/33.jpg`
| `portfolio/produktowa/34.jpg`
| `portfolio/produktowa/pelnowymiarowe/34.jpg`
| `portfolio/produktowa/35.jpg`
| `portfolio/produktowa/pelnowymiarowe/35.jpg`
| `portfolio/produktowa/36.jpg`
| `portfolio/produktowa/pelnowymiarowe/36.jpg`
| `portfolio/produktowa/37.jpg`
| `portfolio/produktowa/pelnowymiarowe/37.jpg`
| `portfolio/produktowa/38.jpg`
| `portfolio/produktowa/pelnowymiarowe/38.jpg`
| `portfolio/produktowa/39.jpg`
| `portfolio/produktowa/pelnowymiarowe/39.jpg`
| `portfolio/produktowa/40.jpg`
| `portfolio/produktowa/pelnowymiarowe/40.jpg`
| `portfolio/reportazowa/1.jpg`
| `portfolio/reportazowa/pelnowymiarowe/1.jpg`
| `portfolio/reportazowa/2.jpg`
| `portfolio/reportazowa/pelnowymiarowe/2.jpg`
| `portfolio/reportazowa/3.jpg`
| `portfolio/reportazowa/pelnowymiarowe/3.jpg`
| `portfolio/reportazowa/4.jpg`
| `portfolio/reportazowa/pelnowymiarowe/4.jpg`
| `portfolio/reportazowa/5.jpg`
| `portfolio/reportazowa/pelnowymiarowe/5.jpg`
| `portfolio/reportazowa/6.jpg`
| `portfolio/reportazowa/pelnowymiarowe/6.jpg`
| `portfolio/reportazowa/7.jpg`
| `portfolio/reportazowa/pelnowymiarowe/7.jpg`
| `portfolio/reportazowa/8.jpg`
| `portfolio/reportazowa/pelnowymiarowe/8.jpg`
| `portfolio/reportazowa/9.jpg`
| `portfolio/reportazowa/pelnowymiarowe/9.jpg`
| `portfolio/reportazowa/10.jpg`
| `portfolio/reportazowa/pelnowymiarowe/10.jpg`
| `portfolio/reportazowa/11.jpg`
| `portfolio/reportazowa/pelnowymiarowe/11.jpg`
| `portfolio/reportazowa/12.jpg`
| `portfolio/reportazowa/pelnowymiarowe/12.jpg`
| `portfolio/reportazowa/13.jpg`
| `portfolio/reportazowa/pelnowymiarowe/13.jpg`
| `portfolio/reportazowa/14.jpg`
| `portfolio/reportazowa/pelnowymiarowe/14.jpg`
| `portfolio/reportazowa/15.jpg`
| `portfolio/reportazowa/pelnowymiarowe/15.jpg`
| `portfolio/reportazowa/16.jpg`
| `portfolio/reportazowa/pelnowymiarowe/16.jpg`
| `portfolio/reportazowa/17.jpg`
| `portfolio/reportazowa/pelnowymiarowe/17.jpg`
| `portfolio/reportazowa/18.jpg`
| `portfolio/reportazowa/pelnowymiarowe/18.jpg`
| `portfolio/reportazowa/19.jpg`
| `portfolio/reportazowa/pelnowymiarowe/19.jpg`
| `portfolio/reportazowa/20.jpg`
| `portfolio/reportazowa/pelnowymiarowe/20.jpg`
| `portfolio/reportazowa/21.jpg`
| `portfolio/reportazowa/pelnowymiarowe/21.jpg`
| `portfolio/reportazowa/22.jpg`
| `portfolio/reportazowa/pelnowymiarowe/22.jpg`
| `portfolio/reportazowa/23.jpg`
| `portfolio/reportazowa/pelnowymiarowe/23.jpg`
| `portfolio/reportazowa/24.jpg`
| `portfolio/reportazowa/pelnowymiarowe/24.jpg`
| `portfolio/reportazowa/25.jpg`
| `portfolio/reportazowa/pelnowymiarowe/25.jpg`
| `portfolio/reportazowa/26.jpg`
| `portfolio/reportazowa/pelnowymiarowe/26.jpg`
| `portfolio/reportazowa/27.jpg`
| `portfolio/reportazowa/pelnowymiarowe/27.jpg`
| `portfolio/reportazowa/28.jpg`
| `portfolio/reportazowa/pelnowymiarowe/28.jpg`
| `portfolio/rodzaj-fotografii/kulinarna.jpg`
| `portfolio/rodzaj-fotografii/produktowa.jpg`
| `portfolio/rodzaj-fotografii/reportazowa.jpg`